module.exports = __webpack_public_path__ + "img/error.4481bc8b.png";